import axios from 'axios'
import { DocumentResponse } from '../../../../api/models'
import { UpdateDocumentRequestV3 } from '../../../../api/models/update-document-request-v3'
import { CreateDocumentRequestV3 } from '../../../../api/models/create-document-request-v3'

const baseUrl = process.env.REACT_APP_API_URL

export async function fetchHouseConsignmentDocumentsV3(
  params: { houseConsignmentId: number; documentType?: string },
  opts?: { signal?: AbortSignal },
) {
  const { data } = await axios.get<DocumentResponse[]>(`${baseUrl}/v3/house-consignment/${params.houseConsignmentId}/documents`, {
    signal: opts?.signal,
    params: {
      documentType: params.documentType,
    },
  })

  return data
}

export async function createHouseConsignmentDocumentsV3(
  houseConsignmentId: number,
  documents: CreateDocumentRequestV3[],
) {
  const { data } = await axios.post<DocumentResponse[]>(`${baseUrl}/v3/house-consignment/${houseConsignmentId}/documents`, documents)
  return data
}

export async function updateHouseConsignmentDocumentsV3(
  houseConsignmentId: number,
  documents: UpdateDocumentRequestV3[],
) {
  const { data } = await axios.put<DocumentResponse[]>(`${baseUrl}/v3/house-consignment/${houseConsignmentId}/documents`, documents)
  return data
}
